module.exports = __webpack_public_path__ + "assets/img/img50.ccb600d7.png";